import * as _ from "lodash";
import {
  LocationsLoaded,
  LocationAdded,
  LocationUpdated,
  LocationCommoditiesUpdated,
  LocationDeleted,
  CommoditiesUpdatedForAllLocations,
  LocationCommodityUpdated,
  DefaultBuyLocationSet
} from "./locations.action";
import PhysicalLocation from "domain/physicalLocation";
import { ReducerBase } from "common/reducer";
import initialState from "app/initialState";

export class LocationsReducer extends ReducerBase<PhysicalLocation[]> {
  constructor() {
    super();
    this.addHandler(LocationsLoaded.EventName, this.handleLocationsLoaded);
    this.addHandler(LocationAdded.EventName, this.handleLocationAdded);
    this.addHandler(LocationUpdated.EventName, this.handleLocationUpdated);
    this.addHandler(LocationCommoditiesUpdated.EventName, this.handleLocationCommoditiesUpdated);
    this.addHandler(LocationDeleted.EventName, this.handleLocationDeleted)
    this.addHandler(LocationCommodityUpdated.EventName, this.handleLocationCommodityUpdate);
    this.addHandler(CommoditiesUpdatedForAllLocations.EventName, this.handleCommoditiesUpdatedForAllLocations);
    this.addHandler(DefaultBuyLocationSet.EventName, this.handleDefaultBuyLocationSet);
  }

  handleLocationsLoaded(
    state: PhysicalLocation[] = initialState.locations,
    event: LocationsLoaded
  ): PhysicalLocation[] {
    return event.locations;
  }

  handleLocationAdded(
    state: PhysicalLocation[] = initialState.locations,
    event: LocationAdded
  ): PhysicalLocation[] {
    return _.sortBy([...state, { ...event.newLocation }], [l => l.name?.toLowerCase()]);
  }

  handleLocationUpdated(
    state: PhysicalLocation[] = initialState.locations,
    event: LocationUpdated
  ): PhysicalLocation[] {
    return  _.sortBy(state.map(t => (t.id === event.location.id ? event.location : t)), [l => l.name?.toLowerCase()]); 
  }

  handleLocationCommoditiesUpdated(
    state: PhysicalLocation[] = initialState.locations,
    event: LocationCommoditiesUpdated
  ): PhysicalLocation[] {
    return state.map(t => (t.id === event.locationId ? { ...t, commodities: event.commodities } : t));
  }

  handleLocationDeleted(
    state: PhysicalLocation[] = initialState.locations,
    event: LocationDeleted
  ): PhysicalLocation[] {
    return state.filter(t => (t.id !== event.location.id));
  }

  handleCommoditiesUpdatedForAllLocations (
    state: PhysicalLocation[] = initialState.locations,
    event: CommoditiesUpdatedForAllLocations
  ): PhysicalLocation[] {
    return state.map(location => ({
      ...location,
      commodities: _.pullAllBy(_.unionBy(location.commodities, event.added, c => c.id), event.removed, c => c.id)
    }));
  }

  handleLocationCommodityUpdate (
      state: PhysicalLocation[] = initialState.locations,
      event: LocationCommodityUpdated
  ): PhysicalLocation[] {
    return state.map(location => ({
      ...location,
      commodities: location.commodities.map(c => c.id === event.commodity.id && location.id === event.locationId ? event.commodity : c)
    }));
  }

  handleDefaultBuyLocationSet (
    state: PhysicalLocation[] = initialState.locations,
    event: DefaultBuyLocationSet
  ): PhysicalLocation[] {
    const x = state.map(location => location.id === event.location.id ? event.location : {...location, isDefaultBuyLocation: false});
    return x;
  }

  handleDefault(state: PhysicalLocation[] = initialState.locations) {
    return state;
  }
}
